import React from 'react';
const Loader = () => {
  return (
    <div className='min-h-screen text-xl text-center flex flex-col justify-around'>
    <div className="loader"></div>
    </div>
  )
}

export default Loader